export const TAB_BAR_TYPE_MENU = "menu"
export const TAB_BAR_TYPE_NAV = "nav"
